module.exports = __webpack_public_path__ + "static/img/miaosha2.66ba218c.png";